import { render, staticRenderFns } from "./FivGoalChart.vue?vue&type=template&id=2da5ac66&scoped=true"
import script from "./FivGoalChart.vue?vue&type=script&lang=ts"
export * from "./FivGoalChart.vue?vue&type=script&lang=ts"
import style0 from "./FivGoalChart.vue?vue&type=style&index=0&id=2da5ac66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5ac66",
  null
  
)

export default component.exports